import { Injectable } from '@angular/core';

import { AddressModel } from '../address/model/address.model';
import { AddressResponseData } from '../address/response/address.response';

/**
 * Service to handle mapping of the service responses.
 */
@Injectable({
  providedIn: 'root'
})
export class ResponseService {
  /**
   * Maps the address items.
   */
  mapAddressItems(items: AddressResponseData[]): AddressModel[] {
    if (!items || items.length === 0) {
      return [];
    }

    return items.map((item: AddressResponseData): AddressModel => this.mapAddress(item));
  }

  // noinspection JSMethodCanBeStatic
  private mapAddress(item: AddressResponseData): AddressModel {
    if (!item) {
      return null;
    }

    return {
      addressLine1: item.line_1,
      addressLine2: item.line_2,
      postcode: item.postcode,
      city: item.post_town,
      subBuildingName: item.sub_building_name,
      buildingName: item.building_name,
      buildingNumber: item.building_number,
      streetName: item.thoroughfare,
      dependantThoroughfare: item.dependant_thoroughfare,
      departmentName: item.department_name,
      organisationName: item.organisation_name,
      uprn: item.uprn,
      udprn: +item.udprn,
      poBox: item.po_box,
      county: item.county,
      country: item.country
    };
  }
}
